import DeleteIcon from '@mui/icons-material/Delete';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SaveIcon from '@mui/icons-material/Save';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/GridLegacy';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import React, { useContext, useEffect, useRef, useState } from 'react';
// import Qr from 'qrcode';

import { useCookies } from 'react-cookie';

import { AppText } from '../../constant';
import { ApiManager } from '../../managers';
import { Container } from './Container';
import { CookieValues, Model, ModelNameEnum, SendRequest } from '@bit-by-bit-software/types';
import { AlertContext, FormInput, FormInputTypeEnum, FormValidated, FormValidatedRef, schemaFieldToFormInput } from '@bit-by-bit-software/ui';
import ApiRequest from '../../api/request';

function Emails() {
  const createFormRef = useRef<FormValidatedRef>(null);

  const { showAlert } = useContext(AlertContext);

  const [cookies] = useCookies<'token', CookieValues>(['token']);

  const [, setIsLoading] = useState<boolean>(false);
  const [templates, setTemplates] = useState<any[]>([]);
  const [createInputs, setCreateInputs] = useState<any[]>([]);
  const [template, setTemplate] = useState<number>(-1);
  const [testMember, setTestMember] = useState<any>(null);
  const [testEvent, setTestEvent] = useState<any>(null);
  const [, setAwsTemplate] = useState<any>(null);
  const [toEmail, setToEmail] = useState<string>('');

  const sendGetDataRequest: SendRequest<{params: { display?: boolean | undefined}, model: ModelNameEnum; }, { model: Model; results: any[] }> = ApiRequest.sendRequest;

  // MARK: - API
  const loadData = async () => {
    try {
      // Load email template schema fields
      // Load email template records

      console.log('Emails.loadData()');
      setIsLoading(true);
      const response = await ApiManager.SendRequest({
        route: 'email',
        action: 'load',
      });
      if (response.error) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: response.error,
          variant: 'danger',
          dismissText: 'okay',
        });
        return;
      }

      const createInputs = [];
      for (let i = 0; i < response.results.schemaFields.length; i++) {
        if (response.results.schemaFields[i].name !== 'createdBy') {
          createInputs.push(
            await schemaFieldToFormInput(response.results.schemaFields[i], sendGetDataRequest, cookies.token),
          );
        }
      }
      setCreateInputs(createInputs);
      setTemplates(response.results.templates);
      setAwsTemplate(response.results.awsTemplate);
      setTestMember(response.results.testMember);
      setTestEvent(response.results.testEvent);
    } catch (err: any) {
      showAlert({
        headerText: 'Uh-oh',
        detailText: `An error has occurred, please try again or contact support.\nError: ${err.message}`,
        variant: 'danger',
        dismissText: 'okay',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const createTemplate = async () => {
    try {
      setIsLoading(true);

      const params: { [key: string]: string | number } = {};
      createInputs.forEach(({ id, value }) => {
        params[id] = value;
      });
      const response = await ApiManager.SendRequest({
        route: 'data',
        action: 'create',
        model: ModelNameEnum.emailtemplate,
        params,
      });
      if (response.error) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: response.error,
          variant: 'danger',
          dismissText: 'okay',
        });
        console.log(response);
        return;
      }

      resetForm();

      setTemplates(prevTemplates => [...prevTemplates, response.results]);

      showAlert({
        headerText: 'Success',
        detailText: 'Template created',
        variant: 'success',
        dismissText: 'okay',
      });
    } catch (err: any) {
      showAlert({
        headerText: 'Uh-oh',
        detailText: `An error has occurred, please try again or contact support.\nError: ${err.message}`,
        variant: 'danger',
        dismissText: 'okay',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const updateTemplate = async () => {
    try {
      setIsLoading(true);

      const params: { [key: string]: string | number } = {};
      createInputs.forEach(({ id, value }) => {
        params[id] = value;
      });

      const response = await ApiManager.SendRequest({
        route: 'data',
        action: 'update',
        model: ModelNameEnum.emailtemplate,
        id: templates[template]._id.toString(),
        params,
      });
      if (response.error) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: response.error,
          variant: 'danger',
          dismissText: 'okay',
        });
        return;
      }

      resetForm();

      setTemplate(-1);

      setTemplates(prevTemplates => [...prevTemplates, response.results]);

      showAlert({
        headerText: 'Success',
        detailText: 'Template updated',
        variant: 'success',
        dismissText: 'okay',
      });
    } catch (err: any) {
      showAlert({
        headerText: 'Uh-oh',
        detailText: `An error has occurred, please try again or contact support.\nError: ${err.message}`,
        variant: 'danger',
        dismissText: 'okay',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteTemplate = async () => {
    try {
      console.log('Emails.updateTemplate()');
      setIsLoading(true);
      const response = await ApiManager.SendRequest({
        route: 'data',
        action: 'delete',
        model: ModelNameEnum.emailtemplate,
        id: templates[template]._id?.toString(),
      });
      if (response.error) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: response.error,
          variant: 'danger',
          dismissText: 'okay',
        });
        return;
      }

      resetForm();

      setTemplate(-1);

      setTemplates(() => templates.splice(template, 1));

      showAlert({
        headerText: 'Success',
        detailText: 'Template deleted',
        variant: 'success',
        dismissText: 'okay',
      });
    } catch (err: any) {
      showAlert({
        headerText: 'Uh-oh',
        detailText: `An error has occurred, please try again or contact support.\nError: ${err.message}`,
        variant: 'danger',
        dismissText: 'okay',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const parse = (fieldName: string) => {
    let input: any = createInputs.filter(input => input.id === fieldName);
    if (input.length > 0) {
      input = input[0];
    } else {
      return '';
    }
    let parsedString = input.value;
    const replaceIdxs = getIndicesOf('{{', input.value);
    let closingIdx = -1;
    let classVal = '';
    let propVal = '';
    let replaceVal = '';

    for (let i = 0; i < replaceIdxs.length; i++) {
      closingIdx = input.value.indexOf('}}', replaceIdxs[i]);
      if (closingIdx !== -1) {
        replaceVal = input.value.substr(replaceIdxs[i] + 2, closingIdx - (2 + replaceIdxs[i]));
        classVal = replaceVal.substr(0, replaceVal.indexOf('.'));
        propVal = replaceVal.substr(replaceVal.indexOf('.') + 1);

        if (classVal.toLowerCase() === 'member') {
          parsedString = parsedString.replace(`{{${replaceVal}}}`, testMember[propVal]);
          console.log(parsedString);
        } else if (classVal.toLowerCase() === 'event') {
          parsedString = parsedString.replace(`{{${replaceVal}}}`, testEvent[propVal]);
        }
      }
    }

    return parsedString;
  };

  const getIndicesOf = (
    inputSearchStr: string,
    inputStr: string,
    caseSensitive: boolean = false,
  ) => {
    const searchStrLen = inputSearchStr.length;
    if (searchStrLen === 0) {
      return [];
    }
    let searchStr = inputSearchStr;
    let str = inputStr;
    let startIndex = 0;
    let index;
    const indices = [];
    if (!caseSensitive) {
      str = str.toLowerCase();
      searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
      indices.push(index);
      startIndex = index + searchStrLen;
    }
    return indices;
  };

  const renderTemplate = async () => {
    try {
      console.log('Emails.renderTemplate()');
      setIsLoading(true);

      const response = await ApiManager.SendRequest({
        route: 'email',
        action: 'sendTemplate',
        params: {
          templateData: {
            SUBJECT: parse('subject'),
            TITLE: parse('title'),
            HEADER_LOGO_URL: parse('headerLogoUrl'),
            FIRST_LINE: parse('firstLine'),
            SECOND_LINE: parse('secondLine'),
            THIRD_LINE: parse('thirdLine'),
            FOURTH_LINE: parse('fourthLine'),
            FOOTER_TEXT: parse('footerText'),
            TWITTER_URL: parse('twitterUrl'),
            FACEBOOK_URL: parse('facebookUrl'),
            INSTAGRAM_URL: parse('instagramUrl'),
            LINKEDIN_URL: parse('linkedInUrl'),
            YOUTUBE_URL: parse('youtubeUrl'),
            HEADER_LOGO_LINK: parse('headerLogoLink'),
          },
          toEmail,
          payload: testMember.fundraisingPageID,
        },
      });

      if (response.error) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: response.error,
          variant: 'danger',
          dismissText: 'okay',
        });
        return;
      }
      showAlert({
        headerText: 'Success',
        detailText: 'Email sent',
        variant: 'success',
        dismissText: 'okay',
      });
    } catch (err: any) {
      showAlert({
        headerText: 'Uh-oh',
        detailText: `An error has occurred, please try again or contact support.\nError: ${err.message}`,
        variant: 'danger',
        dismissText: 'okay',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const createFormOnChange = (change: any, _: boolean) => {
    const key = change.id.substr(change.id.lastIndexOf('.') + 1);
    console.log(`OnChange ${key} set to ${change.value}`);

    const newFormInputs = [...createInputs];
    const createFormInput = newFormInputs.find(input => {
      if ([input.id, input.key].includes(key)) {
        return true;
      }
      return false;
    });

    if (createFormInput) {
      createFormInput.value = change.value;
    }
    setCreateInputs(newFormInputs);
  };

  const resetForm = () => {
    const newCreateInputs = [];
    for (let i = 0; i < createInputs.length; i++) {
      const input = createInputs[i];
      input.value = '';
      newCreateInputs.push(input);
    }
    setCreateInputs(newCreateInputs);
  };

  useEffect(() => {
    loadData();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // console.log(this.state.friends);
  console.log('Emails.render()');
  console.log(createInputs);
  return (
    <Paper>
      <Container>
        <DialogTitle>
          <Typography variant="h3" classes={{ h3: 'friends-title' }} display="block" align="center">
            {AppText.emails.title}
          </Typography>
        </DialogTitle>
        <DialogContent /* dividers */ className="friends-content">
          <FormControl component="fieldset">
            <FormGroup aria-label="notifications">
              <Grid container direction="row" style={{ marginTop: '25px', marginBottom: '25px' }}>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    classes={{ h5: 'preview-title' }}
                    display="block"
                    align="left">
                    {AppText.emails.infoTitle}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" classes={{ body2: 'info-message' }} align="left">
                    {AppText.emails.infoMessage}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" classes={{ body2: 'info-message' }} align="left">
                    {AppText.emails.infoMessageRight}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12} className="template-dropdown">
                <FormControl style={{ width: '100%' }}>
                  <InputLabel id="template-label">Template: </InputLabel>
                  <Select
                    labelId="template-label"
                    id="template-select"
                    className="select-control-element"
                    value={template === -1 ? '' : template}
                    onChange={e => {
                      const inputs = [...createInputs];
                      for (let i = 0; i < inputs.length; i++) {
                        inputs[i].value = '';
                        inputs[i].value = templates[e.target.value][inputs[i].id];
                      }

                      setTemplate(e.target.value);
                      setCreateInputs(inputs);
                    }}>
                    {templates.map((template, i) => (
                      <MenuItem value={i}>{template.templateName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <div className="left-aligned create-form">
                {createInputs.length > 0 && (
                  <FormValidated
                    ref={createFormRef}
                    formInputs={createInputs}
                    formOnChange={createFormOnChange}
                    validateOnInit={false}
                    columns={3}
                    dynamicInputs
                    description=""
                  />
                )}
              </div>

              <Grid container direction="row" className="bottom-section">
                <Grid item xs={11}>
                  <Typography
                    variant="h5"
                    classes={{ h5: 'preview-title' }}
                    display="block"
                    align="left">
                    {AppText.emails.preview}
                  </Typography>

                  <FormInput
                    id="toEmail"
                    type={FormInputTypeEnum.text}
                    label="To email address: "
                    element="input"
                    rowClassName=""
                    formInputOnChange={(change, _) => {
                      setToEmail(change.value);
                    }}
                    errorMessage=""
                    value={toEmail}
                    required=""
                    placeholder=""
                  />

                  <Button color="primary" startIcon={<VisibilityIcon />} onClick={renderTemplate}>
                    Send Test Email
                  </Button>
                </Grid>

                <Grid item xs={1} className="main-btn-section">
                  <Button
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={template === -1 ? createTemplate : updateTemplate}>
                    Save
                  </Button>
                  <Button color="primary" startIcon={<ExitToAppIcon />} onClick={resetForm}>
                    Quit
                  </Button>
                  {template !== -1 && (
                    <Button color="secondary" startIcon={<DeleteIcon />} onClick={deleteTemplate}>
                      Delete
                    </Button>
                  )}
                </Grid>
              </Grid>
            </FormGroup>
          </FormControl>
        </DialogContent>
      </Container>
    </Paper>
  );
}

export default Emails;
